import { Heading2 } from "@/components/podkit/typography/Headings";
import type { FC } from "react";
import { ServiceAccountTokensList } from "@/components/settings/organization/service-accounts/ServiceAccountTokensList";
import { useCreateServiceAccountAccessToken, useGetServiceAccount } from "@/queries/service-account-queries";
import { ErrorMessage } from "@/components/ErrorMessage";
import { serviceAccountHeaders } from "@/api";

export const ServiceAccountTokens: FC<{ serviceAccountId: string }> = ({ serviceAccountId }) => {
    const { data: serviceAccount, error: getServiceAccountError } = useGetServiceAccount({ serviceAccountId });

    // The service account access token is created using the logged in identity
    const { data: serviceAccountAccessToken, error: serviceAccountAccessTokenError } =
        useCreateServiceAccountAccessToken({ serviceAccountId });

    // These headers can be used to perform requests on behalf of the service account
    const headers =
        serviceAccountAccessToken && serviceAccount
            ? serviceAccountHeaders({ serviceAccountId, serviceAccountAccessToken: serviceAccountAccessToken })
            : undefined;

    return (
        <div className="flex flex-col gap-2">
            <div className="flex min-h-7 flex-grow items-center justify-between gap-2">
                <Heading2 className="text-lg font-medium">Tokens</Heading2>
            </div>
            <ErrorMessage error={getServiceAccountError} />
            <ErrorMessage error={serviceAccountAccessTokenError} />
            <ServiceAccountTokensList headers={headers} serviceAccountId={serviceAccountId} />
        </div>
    );
};
